import { Q as Qe } from './index.es.js';

/**
 * Throw error if given value is undefined
 *
 * @param component - component name
 * @param prop - prop name
 * @param value - value to check
 * @throws if value is undefined
 */
function checkRequiredProp(component, prop, value) {
    if ([undefined, null].includes(value))
        throw new Error(`<${component}> prop "${prop}" must be defined`);
    if (typeof value === 'string' && !Qe(value)) {
        throw new Error(`<${component}> prop "${prop}" must not be empty`);
    }
}

export { checkRequiredProp as c };

//# sourceMappingURL=components.utils.js.map